var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/form-validation.j2"] = require( "macros/form-validation.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/modal/request-swatch-selections.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "\n\n";
env.getTemplate("macros/form-validation.j2", false, "product/templates/modal/request-swatch-selections.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("displayGeneralErrors")) {
var t_4 = t_1.displayGeneralErrors;
} else {
cb(new Error("cannot import 'displayGeneralErrors'")); return;
}
context.setVariable("displayGeneralErrors", t_4);
if(t_1.hasOwnProperty("displayFieldErrors")) {
var t_5 = t_1.displayFieldErrors;
} else {
cb(new Error("cannot import 'displayFieldErrors'")); return;
}
context.setVariable("displayFieldErrors", t_5);
if(t_1.hasOwnProperty("hasErrors")) {
var t_6 = t_1.hasErrors;
} else {
cb(new Error("cannot import 'hasErrors'")); return;
}
context.setVariable("hasErrors", t_6);
if(t_1.hasOwnProperty("validatedField")) {
var t_7 = t_1.validatedField;
} else {
cb(new Error("cannot import 'validatedField'")); return;
}
context.setVariable("validatedField", t_7);
output += "\n\n<div class=\"dom-request-swatch-selection\">\n    ";
var t_8;
t_8 = (lineno = 5, colno = 50, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "product"),"productRequestSwatch.selectedSwatches",[]]));
frame.set("requestSwatchSelectedList", t_8, true);
if(frame.topLevel) {
context.setVariable("requestSwatchSelectedList", t_8);
}
if(frame.topLevel) {
context.addExport("requestSwatchSelectedList", t_8);
}
output += "<form novalidate action=\"\" method=\"POST\" class=\"js-request-swatch-selection\">\n\n        <div class=\"c-request-swatch__inner\">\n\n            <div class=\"o-row\">\n                <div class=\"o-column o-extra-small--12\">\n                    <h1 class=\"c-request-swatch__h1\">\n                        ";
output += runtime.suppressValue((lineno = 14, colno = 26, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_request-swatch-modal-title"])), env.opts.autoescape);
output += "\n                    </h1>\n                    <p class=\"c-request-swatch__p\">\n                        ";
output += runtime.suppressValue((lineno = 17, colno = 26, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_request-swatch-modal-page1-block1"])), env.opts.autoescape);
output += "\n                    </p>\n                    <p class=\"c-request-swatch__details\">\n                        ";
output += runtime.suppressValue((lineno = 20, colno = 26, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_request-swatch-modal-page1-block2"])), env.opts.autoescape);
output += "\n                    </p>\n                    <h2 class=\"c-request-swatch__h2\">\n                        ";
output += runtime.suppressValue((lineno = 23, colno = 26, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_request-swatch-modal-page1-subtitle"])), env.opts.autoescape);
output += "\n                    </h2>\n                    <h3 class=\"c-request-swatch__h4\" data-qa-request-swatch-count=";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productRequestSwatch")),"selectedCount"), env.opts.autoescape);
output += ">\n                        ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productRequestSwatch")),"selectedCount"), env.opts.autoescape);
output += " ";
output += runtime.suppressValue((lineno = 26, colno = 71, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_request-swatch-swatches-selected"])), env.opts.autoescape);
output += "\n                        <span class=\"c-request-swatch__h3\" data-qa-request-swatch-product-name>(";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productRequestSwatch")),"selectedProduct")),"displayName"), env.opts.autoescape);
output += ")</span>\n                    </h3>\n                </div>\n            </div>\n\n            <div class=\"o-row\">\n                <div class=\"o-column o-extra-small--12 u-no-gutters\">\n                    <div class=\"c-request-swatch__swatch-container\">\n                        <ul class=\"c-request-swatch__ul\">\n                        ";
frame = frame.push();
var t_11 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productRequestSwatch")),"swatches");
if(t_11) {var t_10 = t_11.length;
for(var t_9=0; t_9 < t_11.length; t_9++) {
var t_12 = t_11[t_9];
frame.set("swatch", t_12);
frame.set("loop.index", t_9 + 1);
frame.set("loop.index0", t_9);
frame.set("loop.revindex", t_10 - t_9);
frame.set("loop.revindex0", t_10 - t_9 - 1);
frame.set("loop.first", t_9 === 0);
frame.set("loop.last", t_9 === t_10 - 1);
frame.set("loop.length", t_10);
output += "\n                            ";
var t_13;
t_13 = runtime.inOperator(t_12,runtime.contextOrFrameLookup(context, frame, "requestSwatchSelectedList"));
frame.set("isSwatchSelected", t_13, true);
if(frame.topLevel) {
context.setVariable("isSwatchSelected", t_13);
}
if(frame.topLevel) {
context.addExport("isSwatchSelected", t_13);
}
output += "\n                            ";
var t_14;
t_14 = (runtime.contextOrFrameLookup(context, frame, "isSwatchSelected")?" c-request-swatch-selection-inner--selected":"");
frame.set("requestSwatchItemSelectedClass", t_14, true);
if(frame.topLevel) {
context.setVariable("requestSwatchItemSelectedClass", t_14);
}
if(frame.topLevel) {
context.addExport("requestSwatchItemSelectedClass", t_14);
}
output += "\n                            ";
var t_15;
t_15 = (runtime.contextOrFrameLookup(context, frame, "isSwatchSelected")?"checked ":"");
frame.set("requestSwatchInputCheckedAttr", t_15, true);
if(frame.topLevel) {
context.setVariable("requestSwatchInputCheckedAttr", t_15);
}
if(frame.topLevel) {
context.addExport("requestSwatchInputCheckedAttr", t_15);
}
output += "\n                            <li class=\"c-request-swatch-selection-outer o-column o-extra-small--6 o-small--4 o-medium--3 o-large--2\">\n                                <div class=\"c-request-swatch-selection-inner js-request-swatch-selection-inner";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "requestSwatchItemSelectedClass"), env.opts.autoescape);
output += "\">\n                                    <img class=\"c-request-swatch__swatch\" src=\"";
output += runtime.suppressValue(runtime.memberLookup((t_12),"url"), env.opts.autoescape);
output += "\" alt=\"";
output += runtime.suppressValue(runtime.memberLookup((t_12),"displayName"), env.opts.autoescape);
output += "\" />\n                                    <div class=\"c-request-swatch-selection-field\">\n                                        <input type=\"checkbox\"\n                                                name=\"requestSwatch_";
output += runtime.suppressValue(runtime.memberLookup((t_12),"colorCode"), env.opts.autoescape);
output += "\"\n                                                class=\"js-request-swatch-selection__checkbox\"\n                                                value=\"";
output += runtime.suppressValue(runtime.memberLookup((t_12),"colorCode"), env.opts.autoescape);
output += "\"\n                                                id=\"request-swatch-selection-";
output += runtime.suppressValue(runtime.memberLookup((t_12),"colorCode"), env.opts.autoescape);
output += "\"\n                                                ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "requestSwatchInputCheckedAttr"), env.opts.autoescape);
output += "\n                                                data-qa-request-swatch-choice=\"";
output += runtime.suppressValue(runtime.memberLookup((t_12),"colorCode"), env.opts.autoescape);
output += "\"/>\n                                        <label for=\"request-swatch-selection-";
output += runtime.suppressValue(runtime.memberLookup((t_12),"colorCode"), env.opts.autoescape);
output += "\"\n                                                class=\"c-request-swatch-selection__label js-request-swatch-selection__label\">";
output += runtime.suppressValue(runtime.memberLookup((t_12),"displayName"), env.opts.autoescape);
output += "</label>\n                                    </div>\n                                </div>\n                            </li>\n                        ";
;
}
}
frame = frame.pop();
output += "\n                        </ul>\n                    </div>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"c-request-swatch__bottom\">\n\n            ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productRequestSwatch")),"selectionError") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productRequestSwatch")),"message")) {
output += "\n            <div class=\"o-row\">\n                <div class=\"o-column o-extra-small--12 u-centered-content has-error\">\n                    <div class=\"c-form-message c-request-swatch__error\">\n                            <p class=\"c-form-message__p\" data-qa-error-field=\"request-swatch-selection-error\">\n                                ";
output += runtime.suppressValue((lineno = 70, colno = 34, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, [runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productRequestSwatch")),"message")),"slug")])), env.opts.autoescape);
output += "\n                            </p>\n                    </div>\n                </div>\n            </div>\n            ";
;
}
output += "\n\n            <div class=\"o-row\">\n                <div class=\"o-column o-extra-small--11 o-small--8 o-large--6 o-extra-small--centered u-no-gutters\">\n                    <div class=\"o-column o-extra-small--6\">\n                        <div class=\"is-disabled\">\n                            <button class=\"c-button-advance-flow--reverse c-request-swatch__button\" type=\"submit\" data-qa-request-swatch-previous disabled>\n                                ";
output += runtime.suppressValue((lineno = 82, colno = 34, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_request-swatch-modal-previous"])), env.opts.autoescape);
output += "\n                            </button>\n                        </div>\n                    </div>\n                    <div class=\"o-column o-extra-small--6\">\n                        <button class=\"c-button-advance-flow c-request-swatch__button js-request-swatch-email\" type=\"submit\" data-action=\"NEXT\" data-qa-request-swatch-next>\n                            ";
output += runtime.suppressValue((lineno = 88, colno = 30, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_request-swatch-modal-next"])), env.opts.autoescape);
output += "\n                        </button>\n                    </div>\n                </div>\n            </div>\n        </div>\n\n    </form>\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/modal/request-swatch-selections.j2"] , dependencies)